import TripsByDirection from '@/components/manage/tickets/TripsByDirection';
import Divider from '@/components/primitives/Divider';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { useBookingTrips } from '@/hooks/useBookingTrips';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import type { CheckoutOrBookingPassengerMap } from '@/types/passenger';
import type { FC } from 'react';

interface BookedTripsDetailsProps {
  passengersMap: CheckoutOrBookingPassengerMap;
}

const Tickets: FC<BookedTripsDetailsProps> = ({ passengersMap }) => {
  const booking = useSelector(manageFlowBookingSelector);
  const { outboundTrips, inboundTrips } = useBookingTrips(booking);

  return (
    <div className="flex flex-1 flex-col">
      <TripsByDirection
        trips={outboundTrips}
        passengersMap={passengersMap}
        header={
          <TransText
            i18nKey="outboundTrips"
            values={{ count: outboundTrips.length }}
          />
        }
      />
      {!!inboundTrips.length && (
        <>
          <Divider className="my-4" grow={false} />
          <TripsByDirection
            trips={inboundTrips}
            passengersMap={passengersMap}
            header={
              <TransText
                i18nKey="returnTrip"
                values={{ count: inboundTrips.length }}
              />
            }
          />
        </>
      )}
    </div>
  );
};

export default Tickets;
